import React, { useState } from 'react'

function BookingArea() {
    const [checkInDate, setCheckInDate] = useState('');
    const [checkOutDate, setCheckOutDate] = useState('');

    // Get today's date in YYYY-MM-DD format
    const today = new Date().toISOString().split('T')[0];

    // Get minimum check-out date (one day after check-in)
    const getMinCheckOutDate = (checkInDate) => {
        if (!checkInDate) return today;
        const date = new Date(checkInDate);
        date.setDate(date.getDate() + 1);
        return date.toISOString().split('T')[0];
    };

    // Handle check-in date change
    const handleCheckInChange = (e) => {
        const selectedDate = e.target.value;
        setCheckInDate(selectedDate);
        
        // If check-out date is less than one day after new check-in date, reset it
        const minCheckOut = getMinCheckOutDate(selectedDate);
        if (checkOutDate && checkOutDate < minCheckOut) {
            setCheckOutDate('');
        }
    };

    // Handle check-out date change
    const handleCheckOutChange = (e) => {
        setCheckOutDate(e.target.value);
    };

    return (
        <div id="booking" className="booking-area p-relative">
            <div className="container">
                <form action="#" className="contact-form" >
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <ul>
                                <li>
                                    <div className="contact-field p-relative c-name">
                                        <label><i className="fal fa-badge-check"></i> Check In</label>
                                        <input 
                                            type="date" 
                                            id="chackin" 
                                            name="date"
                                            min={today}
                                            value={checkInDate}
                                            onChange={handleCheckInChange}
                                        />
                                    </div>
                                </li>
                                <li>
                                    <div className="contact-field p-relative c-name">
                                        <label><i className="fal fa-times-octagon"></i> Check Out</label>
                                        <input 
                                            type="date" 
                                            id="chackout" 
                                            name="date"
                                            min={checkInDate ? getMinCheckOutDate(checkInDate) : today}
                                            value={checkOutDate}
                                            onChange={handleCheckOutChange}
                                            disabled={!checkInDate}
                                        />
                                    </div>
                                </li>
                                <li>
                                    <div className="contact-field p-relative c-name">
                                        <label><i className="fal fa-users"></i> Personas</label>
                                        <select name="adults" id="adu">
                                            <option value="sports-massage">Personas</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                        </select>
                                    </div>
                                </li>
                                <li>
                                    <div className="contact-field p-relative c-name">
                                        <label><i className="fal fa-concierge-bell"></i>Habitaciones</label>
                                        <select name="room" id="rm">
                                            <option value="sports-massage">Habitaciones</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                        </select>
                                    </div>
                                </li>
                                <li>
                                    <div className="slider-btn">
                                        <label><i className="fal fa-calendar-alt"></i></label>
                                        <button 
                                            className="btn ss-btn" 
                                            data-animation="fadeInRight" 
                                            data-delay=".8s"
                                            disabled={!checkInDate || !checkOutDate}
                                        >
                                            Disponibilidad
                                        </button>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default BookingArea
